export const isEmptyRouterQueryString = (str?: string | string[]): boolean => {
    if (typeof str === 'undefined') {
        return true;
    }
    if (Array.isArray(str)) {
        str = str.join('');
    }
    return str.trim() === '';
};
